import styled, {css} from 'styled-components';
import {transition} from 'bukku/settings/style-util';
import WithDirection from 'bukku/settings/withDirection';

const SidebarWrapper = styled.div`
  .isomorphicSidebar {
    z-index: 1000;
    flex: 0 0 280px;
    width: 280px;
    background: ${p => p.theme.sidebar.main};

    .scroll-area {
      height: calc(100vh - 70px) !important;

      /* &.update-available {
        height: calc(100vh - 70px - 48px) !important;
      } */

      &.timeout-available {
        height: calc(100vh - 70px - 60px) !important;
      }

      /* &.timeout-available.update-available {
        height: calc(100vh - 70px - 48px - 60px) !important;
      } */

      .thumb-vertical {
        cursor: pointer;
        background-color: rgba(255, 255, 255, 25%);
        border-radius: inherit;
      }
    }

    @media only screen and (width <= 767px) {
      flex: 0 0 240px !important;
      width: 240px !important;
    }

    &.ant-layout-sider-collapsed {
      @media only screen and (width <= 767px) {
        flex: 0 0 0 !important;
        width: 0;
        min-width: 0 !important;
        max-width: 0 !important;
      }
    }

    .isoLogoWrapper {
      position: relative;
      padding: 0 22px;
      margin: 0;
      overflow: hidden;
      background: ${p => p.theme.sidebar.top};


      p {
        display: inline-block;
        line-height: 70px;
        vertical-align: top;
      }

      p.logo {
        img {
          width: 28px;
        }
      }

      .text {
        font-size: 15.75px;
        font-weight: 300;
        color: black;

        &.hidden {
          opacity: 0;
        }
      }

      &.company {
        height: 70px;
        text-align: left;

        .logo-container {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: center;    
          width: 196px;    
          height: 100%;

          ${transition()};

          .logo {
            img {
              height: 43.55px;
            }
          }

          .text {
            min-width: 0;
            padding-left: 10px;
            font-size: 15.75px;
            font-weight: 300;
            color: white;

            .subdomain-container {
              display: flex;
              flex-flow: row nowrap;
              align-items: center;
              margin-bottom: 12px;
              cursor: pointer;

              .subdomain {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }

      &.notice-box {
        text-align: left;
        
        &.update {
          height: 48px;
          background: #389e0d;
        }

        &.timeout {
          height: 60px;
          background: #fa8c16;
        }

        .notice-box-container {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: flex-start;
          height: 100%;
          ${transition()};

          .logo {
            font-size: 20px;
            line-height: 48px;

            .anticon.exclaim {
              font-size: 20px;
              line-height: 48px;
            }
          }

          .text {
            min-width: 150px;
            padding-top: 0 !important;
            padding-left: 29px;
            font-size: 12px;
            line-height: 16px !important;
            color: white;

            strong {
              font-size: 14px;
            }

            &.hidden {
              opacity: 0;
            }
          }
        }
      }
    }

    /* stylelint-disable-next-line no-duplicate-selectors */
    &.ant-layout-sider-collapsed {
      .isoLogoWrapper {
        &.company {
          .logo-container {
            justify-content: flex-start;

            .text {
            }
          }
        }
      }
    }

     /* List Menu starts here */
    .isoDashboardMenu {
      padding-top: 30px;
      padding-bottom: 90px;
      background: transparent;

       /* Sidebar Icon */
      .sidebar-icon {
        position: relative;
        top: 1px;
        width: 18px;
        margin: ${props => (props['data-rtl'] === 'rtl' ? '0 0 0 16px' : '0 16px 0 0')};
        font-size: 18px !important;
        line-height: 20px;   
        color: ${p => p.theme.sidebar.text};
        ${transition()};
      }

       /* Sidebar Text */
      .sidebar-text, .sidebar-submenu-text {
        margin-left: 0 !important;
        font-weight: 400;
        line-height: 20px;
        color: ${p => p.theme.sidebar.text};

        ${transition()};
        > a {
          text-decoration: none;
        }
      }

      .sidebar-text {
        font-size: 14px;
      }

      .sidebar-submenu-text {
        font-size: 13px;
      }

       /* Main Item */
      .ant-menu-item {
        display: flexbox;
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0 24px;
        margin: 0;
        -ms-flex-align: center;

        &.ant-menu-item-only-child {
          height: 44.02px;
        }

         /* Main Item: When Hovered */
        &:not(.ant-menu-item-locked):hover {
          background-color: ${p => p.theme.sidebar.mainHover};

          .sidebar-icon, .sidebar-text, .sidebar-submenu-text {
            color: ${p => p.theme.sidebar.textHover};
          }

          .sidebar-locked-icon {
            /* color: #ffa39eDD!important; */
          }
        }

       /* Main Item: When Selected */
        &.ant-menu-item-selected {
          background-color: ${p => p.theme.sidebar.selected};

          /* stylelint-disable-next-line no-descending-specificity */
          .sidebar-icon, .sidebar-text, .sidebar-submenu-text {
            color: ${p => p.theme.sidebar.textSelected};
          }

          /* stylelint-disable-next-line no-descending-specificity */
          .sidebar-text, .sidebar-submenu-text {
            font-weight: 500;
          }
        }

       /* Main Item: When Selected & Hovered */
        &.ant-menu-item-selected:hover {
          background-color: ${p => p.theme.sidebar.selectedHover};

          .sidebar-icon, .sidebar-text, .sidebar-submenu-text {
            color: ${p => p.theme.sidebar.textSelectedHover};
          }

          .sidebar-text, .sidebar-submenu-text {
            font-weight: 500;
          }

          .sidebar-locked-icon {
            /* color: #ffa39eDD!important; */
          }
        }
      }
    }

    .ant-menu-submenu-inline,
    .ant-menu-submenu-vertical {
       /* Submenu Title */
      > .ant-menu-submenu-title {
        display: flex;
        align-items: center;
        width: 100%;
        height: 44.02px;
        padding: 0 24px;
        margin: 0;

        > .ant-menu-submenu-arrow {
          &::before, &::after {
            background: ${p => p.theme.sidebar.arrow};
          }
        }

        &:hover {
          background-color: ${p => p.theme.sidebar.mainHover};

          /* stylelint-disable-next-line no-descending-specificity */
          .sidebar-icon, .sidebar-text {
            color: ${p => p.theme.sidebar.textHover};
          }

          /* stylelint-disable-next-line no-descending-specificity */
          .sidebar-locked-icon {
            color: #ffa39eDD!important;
          }

          > .ant-menu-submenu-arrow {
            &::before, &::after {
              background: ${p => p.theme.sidebar.arrowHover};
            }
          }
        }

        > span {
          display: flex;
          align-items: center;
        }
      }

      .ant-menu-sub {
        background-color: transparent !important;
        box-shadow: none;

       /* Submenu Item */
        /* stylelint-disable-next-line no-descending-specificity */
        .ant-menu-item {
          background-color: ${p => p.theme.sidebar.submenu};

           /* Submenu Item: When Hovered */
          &:not(.ant-menu-item-locked):hover {
            background-color: ${p => p.theme.sidebar.submenuHover};

            .sidebar-text {
              color: ${p => p.theme.sidebar.submenuTextHover};
            }
          }

           /* Submenu Item: When Selected */
          &.ant-menu-item-selected {
            background-color: ${p => p.theme.sidebar.submenuSelected};

            /* stylelint-disable-next-line no-descending-specificity */
            .sidebar-text {
              color: ${p => p.theme.sidebar.submenuTextSelected};
            }
          }

           /* Submenu Item: When Selected */
          &.ant-menu-item-selected:hover {
            background-color: ${p => p.theme.sidebar.submenuSelectedHover};

            .sidebar-text {
              color: ${p => p.theme.sidebar.submenuTextSelectedHover};
            }
          }
        }
      }

       /* When any Submenu Item is selected */
      &.ant-menu-submenu-selected {
         /* When Closed */
        &:not(.ant-menu-submenu-open) > .ant-menu-submenu-title {
          background-color: ${p => p.theme.sidebar.selected};

          /* stylelint-disable-next-line no-descending-specificity */
          .sidebar-icon, .sidebar-text {
            color: ${p => p.theme.sidebar.textSelected};
          }

          /* stylelint-disable-next-line no-descending-specificity */
          .sidebar-text, .sidebar-submenu-text {
            font-weight: 500;
          }

          .sidebar-locked-icon {
            color: #ffa39eDD!important;
          }

          .ant-menu-submenu-arrow {
            &::before, &::after {
              background: ${p => p.theme.sidebar.arrowSelected};
            }
          }
        }

         /* When Closed & Hovered */
        &:not(.ant-menu-submenu-open):hover > .ant-menu-submenu-title {
          background-color: ${p => p.theme.sidebar.selectedHover};

          .sidebar-icon, .sidebar-text {
            color: ${p => p.theme.sidebar.textSelectedHover};
          }

          .sidebar-text, .sidebar-submenu-text {
            font-weight: 500;
          }

          .sidebar-locked-icon {
            color: #ffa39eDD!important;
          }

          .ant-menu-submenu-arrow {
            &::before, &::after {
              background: ${p => p.theme.sidebar.arrowSelectedHover};
            }
          }
        }

         /* > .ant-menu-submenu-title {
             background-color: ${p => p.theme.sidebar.selected};
           .sidebar-icon, .sidebar-text {
               color: ${p => p.theme.sidebar.textSelected};
           }
         } */
      }

      .ant-menu-inline,
      .ant-menu-submenu-vertical {
        > li:not(.ant-menu-item-group) {
          padding-right: ${props => (props['data-rtl'] === 'rtl' ? '60px !important' : '0px !important')};
          padding-left: ${props => (props['data-rtl'] === 'rtl' ? '0px !important' : '60px !important')};
          margin: 0;
          ${transition()};
        }

        .ant-menu-item-group {
          padding-left: 0;

          .ant-menu-item-group-title {
            padding-left: 100px !important;
          }

          .ant-menu-item-group-list {
            .ant-menu-item {
              padding-left: 125px !important;
            }
          }
        }
      }
    }

    /* stylelint-disable-next-line no-duplicate-selectors */
    &.ant-layout-sider-collapsed {
      /* stylelint-disable-next-line no-descending-specificity */
      .sidebar-text {
        display: none;
      }

      /* stylelint-disable-next-line no-descending-specificity */
      .ant-menu-item:not(.ant-menu-item-selected) {
        /* stylelint-disable-next-line no-descending-specificity */
        .sidebar-main-item-locked > .sidebar-icon {
          color: ${p => p.theme.sidebar.iconNotInSubscription};
        }
      }

      .ant-menu-submenu-inline > {
        .ant-menu-submenu-title::after {
          display: none;
        }
      }

      .ant-menu-submenu-vertical {
        > .ant-menu-submenu-title::after {
          display: none;
        }

        .ant-menu-sub {
          background-color: transparent !important;

          /* stylelint-disable-next-line no-descending-specificity */
          .ant-menu-item {
            height: 35px;
          }
        }
      }
    }
  }

  /* stylelint-disable-next-line no-descending-specificity */
  .ant-menu-submenu-arrow {
    /* background: red; */
    height: 10px;

    /* top: 50%; */
  }

  /* stylelint-disable-next-line no-descending-specificity */
  .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
    transform: rotate(0deg) translateY(-25%);
    transform-origin: center;
  }

  /* stylelint-disable-next-line no-descending-specificity */
  .ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
    transform: rotate(0deg) translateY(0%);
    transform-origin: center;
  }

  .ant-menu-item-locked {
    cursor: not-allowed !important;
  }

  .shoebox-count-badge {
    padding-left: 4px;
  }

  /**
  Necessary to prevent an Antd bug:
  - BUG: Upon closing the sidebar, the menu popup (of Antd's Menu with mode="vertical") 
         will flash for a split second.
  - Condition of Bugs:
       - openKeys is provided (externally tracked)
       - when collapsed, the mode of Antd's Menu is changed from "inline" to "vertical"
  */
  .ant-menu-submenu.ant-menu-submenu-popup.ant-menu.sidebar {
    /* .ant-menu.ant-menu-sub.ant-menu-vertical { */
    display: none

    /* } */
  }

`;

export const SidebarGlobalStyle = css`
  .ant-menu-inline-collapsed-tooltip .ant-menu-item-icon,
  .ant-menu-inline-collapsed-tooltip .anticon.sidebar-locked-icon {
    display: inherit;
  }
`;

export default WithDirection(SidebarWrapper);
